// Import
import i18n from '@/i18n'
import Vue from 'vue'
import store from '@/store'
import { Api } from '@/core/api.js'

import { FORMAT } from '@/constants'

import localforage from 'localforage'
const api = new Api()

var db_templates = localforage.createInstance({
    name: 'alexdb',
    storeName: 'templates'
})

// Triquiñuela para resetear el state
const getDefaultState = () => {
    return {
        stats: {
            alerts: {},
            activity: {}
        },
        items: {},
        supervisor: false,
        templates: {},
        headers: {},
        type: 2,
        config: {
            date_format: 'YYYY-MM-DD',
            hour_format: 'HH:mm',
            datetime_format: 'YYYY-MM-DD HH:mm',
            has_score: true,
            has_state: false,
            has_timing: false,
            has_mandatory: false,
            is_autosave: true,
            can_create: true,
            item_search: false,
            has_calendar: false,
            temporal_view: false,
            close_when_completed: false,
            auth_users: {
                pin: 2,
                review: 2,
                task: 1
            },
            can_edit: {
                title: false,
                state: false,
                inPast: false,
                inTime: true,
                inFuture: true
            },
            item: {
                itemsTitle: [FORMAT.TITLE, FORMAT.SUBTITLE],
                itemsImage: [FORMAT.PHOTO, FORMAT.SIGNATURE],
                itemsInfo: [FORMAT.DOCUMENT, FORMAT.MESSAGE],
                itemsExcluded: [FORMAT.TITLE, FORMAT.SUBTITLE, FORMAT.DOCUMENT, FORMAT.MESSAGE, FORMAT.LINK, FORMAT.RESOURCE],
                itemsVisibles: [FORMAT.TITLE, FORMAT.SUBTITLE, FORMAT.MESSAGE],
                can_pospone: false,
                rate: true, // Esto es por si van a tener puntuaciones en funcion de lo que se responda
                can_review: false,
                has_periodicity: false,
                has_score: true
            }
        }
    }
}

// initial state
const state = getDefaultState()

// getters
const getters = {
    // Commons
    getAll: (state, getters, rootState) => {
        return state.items
    },
    getById: (state, getters, rootState) => id => {
        return id ? state.items[id] : false
    },
    getConfig: (state, getters, rootState) => {
        return { ...state.config }
    },
    getTemplates: (state, getters, rootState) => {
        return state.templates
    },
    getTemplateById: (state, getters, rootState) => id => {
        return state.templates[id] ? state.templates[id] : {}
    },
    getSubtasks: (state, getters, rootState) => (check, task) => {
        let tasks = check ? state.items[check] : {}
        let subtask = []

        if (tasks.sections) {
            Object.keys(tasks.sections).map(function(sec_id, i) {
                var section = tasks.sections[sec_id]

                Object.keys(section.items).map(function(item_id, i) {
                    var item = section.items[item_id]

                    if (item.parent_id == task) {
                        subtask.push(item.item_id)
                    }
                })
            })
        }

        return subtask
    },

    getAllStats: (state, getters, rootState) => {
        return state.stats
    },
    getStats: (state, getters, rootState) => wich => {
        return state.stats[wich]
    },

    // Audits
    getSectionFromItem: (state, getters, rootState) => (check, task) => {
        var checklist = state.items[check] ? state.items[check] : {}
        var result = false

        Object.keys(checklist.sections).map(function(sec_id, i) {
            var section = checklist.sections[sec_id]

            Object.keys(section.items).map(function(item_id, o) {
                var item = section.items[item_id]
                if (item.item_id == task) {
                    result = section.section_id
                }
            })
        })

        return result
    },
    getItems: (state, getters, rootState) => {
        return state.items
    },
    getHeaders: (state, getters, rootState) => {
        return state.headers
    },
    getSupervisor: (state, getters, rootState) => {
        return state.supervisor ? state.supervisor : false
    }
}

// actions
const actions = {
    // Commonisimos, está en todos los modules
    resetState({ commit }) {
        commit('resetState')
    },

    // Common
    addIssue(context, params) {
        context.dispatch('calcScore', params.checklist_ref)

        var oData = { template: params.tpl_id }
        if (params.checklist_ref) {
            oData.checklist_ref = params.checklist_ref

            let check = context.getters.getById(params.checklist_ref)
            let total = check.total_score
            let answered = check.completed
            let score = check.score
            let resume = { it: 0, is: 0, a: 0, n: 0 }

            for (let section_id in check.sections) {
                let section = check.sections[section_id]

                for (let item_id in section.items) {
                    let item = section.items[item_id]

                    if (item.is_visible && !state.config.item.itemsExcluded.includes(item.type)) {
                        if (!item.complete_date && item.apply) resume.it++ // if item does not have completed_date
                        if (item.message) resume.n++ // if item has notes
                        if (item.alerts && item.alerts.issues.length > 0) resume.is++ // if item has alerts and has issue
                        if (item.alerts && item.alerts.issues.length == 0) resume.a++ // if item has alerts and does not have issue
                    }
                }
            }

            oData.total = total
            oData.answered = answered
            oData.score = score
            oData.resume = JSON.stringify(resume)
        }

        if (params.item_ref) {
            oData.item_ref = params.item_ref
        }

        return api.post('checklist/add', oData).then(function(response) {
            var items = { ...state.items }
            var reference = { checklist: Object.values(response.data)[0].id, type: Object.values(response.data)[0].type, status: Object.values(response.data)[0].status }
            var item = { ...items[params.checklist_ref].items[params.item_ref] }
            item.reference = reference
            items[params.checklist_ref].items[params.item_ref] = item
            Vue.set(state, 'items', items)
            return response.data
        })
    },

    comment(context, params) {
        context.dispatch('calcScore', params.check)

        let check = context.getters.getById(params.check)
        let total = check.total_score
        let answered = check.completed
        let score = check.score
        let resume = { it: 0, is: 0, a: 0, n: 1 }

        for (let section_id in check.sections) {
            let section = check.sections[section_id]

            for (let item_id in section.items) {
                let item = section.items[item_id]

                if (item.is_visible && !state.config.item.itemsExcluded.includes(item.type)) {
                    if (!item.complete_date && item.apply) resume.it++ // if item does not have completed_date
                    if (item.message) resume.n++ // if item has notes
                    if (item.alerts && item.alerts.issues.length > 0) resume.is++ // if item has alerts and has issue
                    if (item.alerts && item.alerts.issues.length == 0) resume.a++ // if item has alerts and does not have issue
                }
            }
        }

        var sended = {
            checklist: params.check,
            task: params.answer,
            message: params.message,
            total: total,
            answered: answered,
            score: score,
            resume: JSON.stringify(resume)
        }

        if (typeof params.file !== 'undefined') sended.file = params.file

        return api.post('checklist/task/comment', sended).then(function(response) {
            var returned = {
                check: params.check,
                answer: params.answer,
                message: response.data.message,
                getters: context.getters
            }
            if (typeof response.data.image !== 'undefined') {
                returned.image = response.data.image
            }

            return context.commit('setComment', returned)
        })
    },

    complete(context, params) {
        context.dispatch('calcScore', params.check)

        var supervisor = context.getters['getSupervisor']
        supervisor = supervisor || params.emp

        let check = context.getters.getById(params.check)
        let resume = { it: 0, is: 0, a: 0, n: 0 }

        for (let section_id in check.sections) {
            let section = check.sections[section_id]

            for (let item_id in section.items) {
                let item = section.items[item_id]

                if (item.is_visible && !state.config.item.itemsExcluded.includes(item.type)) {
                    if (!item.complete_date && item.apply) resume.it++ // if item does not have completed_date
                    if (item.message) resume.n++ // if item has notes
                    if (item.alerts && item.alerts.issues.length > 0) resume.is++ // if item has alerts and has issue
                    if (item.alerts && item.alerts.issues.length == 0) resume.a++ // if item has alerts and does not have issue
                }
            }
        }

        return api
            .post('checklist/complete', {
                checklist: params.check,
                employee: supervisor,
                complete_date: params.date,
                values: params.values,
                resume: JSON.stringify(resume)
                // type: context.state.type,
            })
            .then(function(response) {
                var checklist = context.getters['getById'](params.check)
                checklist.complete_date = moment()

                Object.keys(state.templates).map(function(tpl_id, i) {
                    var tpl = state.templates[tpl_id]

                    if (tpl.id == checklist.template_id) {
                        tpl.last_audit = checklist
                        tpl.last_update = moment()
                        tpl.num_progress--
                    }
                })

                // TODO
                params.values = JSON.parse(params.values)
                Object.keys(params.values).map(function(id, i) {
                    var val = params.values[id]
                    context.commit('setAnswer', {
                        check: params.check,
                        answer: val.item_id,
                        emp: supervisor,
                        date: params.date,
                        value: val.value,
                        getters: context.getters
                    })
                })

                context.dispatch('calcScore', params.check)
                return response
            })
    },

    loadById(context, params) {
        return api.get('checklist/id/' + params.id, {}).then(function(response) {
            context.dispatch('format', { data: response.data })
            context.dispatch('calcScore', params.id)
        })
    },

    loadTemplates(context, params) {
        var templates = []
        var count = 0

        if (context.rootState.refresh.templates && fnCheckConnection()) {
            return api.get('checklist/templates/' + state.type, {}).then(function(response) {
                context.commit('setTemplates', { data: response.data })

                _.forEach(_.values(response.data), function(value, key) {
                    db_templates.setItem(value.id, value)
                })

                var lastAudits = {}

                Object.keys(response.data).map(function(tpl_id, i) {
                    var tpl = { ...response.data[tpl_id] }
                    if (tpl.last_audit) {
                        lastAudits[tpl.last_audit.id] = tpl.last_audit
                    }
                })

                context.dispatch('format', { data: lastAudits })
                context.dispatch('calcScore')
                context.rootState.refresh.templates = false
            })
        } else {
            db_templates
                .iterate(function(value, key, iterationNumber) {
                    if (value.type == state.type) {
                        templates.push(value)
                        count++
                    }
                })
                .then(function() {
                    if (count > 0) {
                        context.commit('setTemplates', { data: templates })
                    }
                })
        }
    },

    reload(context, params) {
        // TODO REVIEW checklist...?????
        context.dispatch('format', { data: checklist })
        context.dispatch('calcScore')
    },

    // Common but may change in other tools
    answer(context, params) {
        if (fnCheckConnection()) {
            let value = params.value
            let subtask = context.getters.getSubtasks(params.check, params.answer)
            let supervisor = context.getters['getSupervisor']
            supervisor = supervisor || params.emp

            // In case of image or signature type, JSON-parse the value
            if (state.config.item.itemsImage.includes(params.answer_type)) {
                value = JSON.stringify(value)
            }

            context.commit('setAnswer', {
                check: params.check,
                answer: params.answer,
                emp: supervisor,
                date: params.date,
                value: params.value,
                getters: context.getters
            })

            context.dispatch('calcScore', params.check)

            if (subtask.length > 0) {
                Object.keys(subtask).map(function(item_id, i) {
                    var item = subtask[item_id]
                    context.commit('setReset', { check: params.check, answer: item })
                })
            }

            let check = context.getters.getById(params.check)
            let total = check.total_score
            let answered = check.completed
            let score = check.score
            let resume = { it: 0, is: 0, a: 0, n: 0 }

            for (let section_id in check.sections) {
                let section = check.sections[section_id]

                for (let item_id in section.items) {
                    let item = section.items[item_id]

                    if (item.is_visible && !state.config.item.itemsExcluded.includes(item.type)) {
                        if (!item.complete_date && item.apply) resume.it++ // if item does not have completed_date
                        if (item.message) resume.n++ // if item has notes
                        if (item.alerts && item.alerts.issues.length > 0) resume.is++ // if item has alerts and has issue
                        if (item.alerts && item.alerts.issues.length == 0) resume.a++ // if item has alerts and does not have issue
                    }
                }
            }

            return api
                .post('checklist/task/answer', {
                    checklist: params.check,
                    task: params.answer,
                    employee: supervisor,
                    complete_date: params.date,
                    value: value,
                    total: total,
                    answered: answered,
                    score: score,
                    resume: JSON.stringify(resume)
                })
                .then(function(response) {
                    if (!response.status) {
                        context.commit('setReset', { check: params.check, answer: params.answer })
                        context.dispatch('calcScore', params.check)
                    }

                    return response
                })
        } else {
            context.commit('setReset', { check: params.check, answer: params.answer })
            return { status: false }
        }
    },

    apply(context, params) {
        let subtask = context.getters.getSubtasks(params.check, params.answer)
        let supervisor = context.getters['getSupervisor']
        supervisor = supervisor || params.emp

        context.commit('setApply', {
            check: params.check,
            answer: params.answer,
            emp: params.emp,
            date: params.date == 0 ? params.date : false,
            apply: params.apply,
            getters: context.getters
        })

        context.dispatch('calcScore', params.check)

        if (subtask.length > 0) {
            Object.keys(subtask).map(function(item_id, i) {
                var item = subtask[item_id]
                context.commit('setReset', { check: params.check, answer: item })
            })
        }

        let check = context.getters.getById(params.check)
        let total = check.total_score
        let answered = check.completed
        let score = check.score
        let resume = { it: 0, is: 0, a: 0, n: 0 }

        for (let section_id in check.sections) {
            let section = check.sections[section_id]

            for (let item_id in section.items) {
                let item = section.items[item_id]

                if (item.is_visible) {
                    if (!item.complete_date && item.apply) resume.it++ // if item does not have completed_date
                    if (item.message) resume.n++ // if item has notes
                    if (item.alerts && item.alerts.issues.length > 0) resume.is++ // if item has alerts and has issue
                    if (item.alerts && item.alerts.issues.length == 0) resume.a++ // if item has alerts and does not have issue
                }
            }
        }

        return api
            .post('checklist/task/apply', {
                checklist: params.check,
                task: params.answer,
                employee: supervisor,
                complete_date: params.date,
                apply: params.apply,
                total: total,
                answered: answered,
                score: score,
                resume: JSON.stringify(resume)
            })
            .then(function(response) {
                if (!response.status) {
                    context.commit('setReset', { check: params.check, answer: params.answer })
                }
            })
    },

    applyrecurrent(context, params) {
        let subtask = context.getters.getSubtasks(params.check, params.answer)
        let supervisor = context.getters['getSupervisor']
        supervisor = supervisor || params.emp

        context.commit('setApply', {
            check: params.check,
            answer: params.answer,
            emp: params.emp,
            date: params.date == 0 ? params.date : false,
            apply: params.apply,
            getters: context.getters
        })

        context.dispatch('calcScore', params.check)

        if (subtask.length > 0) {
            Object.keys(subtask).map(function(item_id, i) {
                var item = subtask[item_id]
                context.commit('setReset', { check: params.check, answer: item })
            })
        }

        let check = context.getters.getById(params.check)
        let total = check.total_score
        let answered = check.completed
        let score = check.score
        let resume = { it: 0, is: 0, a: 0, n: 0 }

        for (let section_id in check.sections) {
            let section = check.sections[section_id]

            for (let item_id in section.items) {
                let item = section.items[item_id]

                if (item.is_visible) {
                    if (!item.complete_date && item.apply) resume.it++ // if item does not have completed_date
                    if (item.message) resume.n++ // if item has notes
                    if (item.alerts && item.alerts.issues.length > 0) resume.is++ // if item has alerts and has issue
                    if (item.alerts && item.alerts.issues.length == 0) resume.a++ // if item has alerts and does not have issue
                }
            }
        }

        return api
            .post('checklist/task/applyrecurrent', {
                checklist: params.check,
                task: params.answer,
                employee: supervisor,
                complete_date: params.date,
                apply: params.apply,
                total: total,
                answered: answered,
                score: score,
                resume: JSON.stringify(resume)
            })
            .then(function(response) {
                if (!response.status) {
                    context.commit('setReset', { check: params.check, answer: params.answer })
                }
            })
    },

    reset(context, params) {
        let subtask = context.getters.getSubtasks(params.check, params.answer)

        return api
            .post('checklist/task/reset', {
                checklist: params.check,
                task: params.answer
            })
            .then(function(response) {
                context.commit('setReset', {
                    check: params.check,
                    answer: params.answer,
                    getters: context.getters
                })
                context.dispatch('calcScore', params.check)

                if (subtask.length > 0) {
                    Object.keys(subtask).map(function(item_id, i) {
                        var item = subtask[item_id]
                        context.commit('setReset', { check: params.check, answer: item, getters: context.getters })
                    })
                }
            })
    },
    add(context, params) {
        var type = context.state.type
        var oData = { template: params.tpl_id }
        if (params.emp_ref) {
            oData.employee_ref = params.emp_ref
        }
        if (params.checklist_ref) {
            oData.checklist_ref = params.checklist_ref
        }
        if (params.item_ref) {
            oData.item_ref = params.item_ref
        }

        return api.post('checklist/add', oData).then(function(response) {
            context.dispatch('format', { data: response.data })
            context.dispatch('calcScore', Object.keys(response.data)[0])

            Object.keys(state.templates).map(function(tpl_id, i) {
                var tpl = state.templates[tpl_id]

                if (tpl.id == params.tpl_id) {
                    tpl.num_progress++
                }
            })
            return response.data[Object.keys(response.data)[0]]
        })
    },

    delete(context, params) {
        log(params)
        var oData = {
            checklist: params.check,
            employee: params.emp,
            status: -1
        }
        if (params.ref_item) {
            oData['ref_item'] = params.ref_item
        }

        return api.post('checklist/update', oData).then(function(response) {
            var audit = { ...context.state.items[params.check] }
            var tpl = { ...context.state.templates[params.template] }
            log(tpl)
            log(audit)

            //   context.commit('removeItem', audit.id)
            // TODO REMOVE LOCAL AUDIT AND NUMBER OF CURRENT AUDITS IF STATUS == progress
            if (context.state.items[params.check].status == 'progress') {
                tpl.num_progress--
                context.commit('setTemplate', tpl)
            }
            return response
        })
    },

    loadStats(context, params) {
        context.commit('resetStats', {})
        var currentDate = moment(params.date)

        // SET ALERTS --------------------------------------------------------------

        // SET ACTIVITY ------------------------------------------------------------

        // -- Created Audits
        context.dispatch('loadFromDate', { date: currentDate.format('YYYY-MM-DD') }).then(function(response) {
            let result = response.data ? Object.keys(response.data).length : 0
            if (response.data && result > 0) {
                context.commit('setStats', {
                    where: 'activity',
                    key_name: 'created',
                    values: {
                        name: i18n.tc('home.activity.registers_generated', result),
                        value: result
                    }
                })
            }
        })
    },

    format({ state, context, commit, dispatch, rootState }, params = {}) {
        var aItems = {}

        if (typeof params.data !== 'undefined') {
            Object.keys(params.data).map(function(list_id, e) {
                var list = params.data[list_id]

                // Timezone set
                list.business_date = list.business_date ? (moment.isMoment(list.business_date) ? list.business_date : moment(list.business_date * 1000)) : false
                list.created_date = list.created_date ? (moment.isMoment(list.created_date) ? list.created_date : moment(list.created_date * 1000)) : false
                list.complete_date = list.complete_date ? (moment.isMoment(list.complete_date) ? list.complete_date : moment(list.complete_date * 1000)) : false

                if (list.business_date.valueOf() < moment().valueOf() && list.started == 0) list.state = 'past'
                else if (list.business_date.valueOf() > moment().valueOf()) list.state = 'future'
                else list.state = 'intime'

                list.def = state.config
                list.uncompleted = 0
                list.completed = 0
                list.unanswered = 0
                list.total = 0
                list.score = -1
                list.grade = false

                // Loop for all sections
                Object.keys(list.sections).map(function(sec_id, i) {
                    var section = list.sections[sec_id]

                    section.completed = 0
                    section.total = 0
                    section.score = -1

                    // Loop for all items
                    Object.keys(section.items).map(function(item_id, o) {
                        var item = section.items[item_id]

                        // Timezone set
                        item.complete_date = item.complete_date ? (moment.isMoment(item.complete_date) ? item.complete_date : moment(item.complete_date * 1000)) : false
                        if (item.review) {
                            item.review['complete_date'] = item.review.complete_date ? (moment.isMoment(item.review.complete_date) ? item.review.complete_date : moment(item.review.complete_date * 1000)) : false
                        }

                        // If type image - Split value to array
                        if (state.config.item.itemsImage.includes(item.type)) {
                            item.value = item.value ? item.value.split(',') : item.value
                        }

                        item.complete_date = item.complete_date
                        item.available = 0
                        item.apply = parseInt(item.apply) == 1

                        item.config = item.config ? JSON.parse(item.config) : JSON.parse('{}')

                        section.items[item.item_id] = { ...item }
                        Vue.set(section.items, item.item_id, { ...item })
                        // list.sections[sec_id].items[item.id] = { ...item };
                        // Vue.set(list.sections[sec_id].items, item.id, { ...item });
                    })

                    list.sections[section.section_id] = { ...section }
                    Vue.set(list.sections, section.section_id, { ...section })
                })

                aItems[list.id] = list
            })
        }

        commit('setFormat', { items: aItems })
    },
    calcScore({ state, context, commit, dispatch, rootState }, id) {
        var aItems = state.items
        var aTemplates = state.templates
        var last_audits = []

        // var alert_pending_count = {};
        // var alert_pending_show = {};
        // var alert_important_show = {};

        Object.keys(aTemplates).map(function(tpl_id, o) {
            var template = aTemplates[tpl_id]

            if (template.last_audit) {
                last_audits.push(template.last_audit.id)
            }
        })

        Object.keys(aItems).map(function(list_id, e) {
            // console.log(list_id, id)
            var list = aItems[list_id]
            var template = aTemplates[list.template_id]
            if (typeof id == 'undefined' || list_id == id) {
                // console.log('--ENTRO--')
                // var past_score = list.score ? list.score : 0;

                if (last_audits.includes(list.id)) {
                    template.completed = 0
                    template.total = 0
                    template.total_score = 0
                    template.last_score = 0
                }

                list.def = state.config
                list.uncompleted = 0
                list.completed = 0
                list.unanswered = 0
                list.total_score = 0
                list.total = 0
                list.score = 0

                // Set status of the Audit
                if (moment(list.business_date) > moment()) {
                    list.status = 'scheduled'
                } else if (list.complete_date) {
                    list.status = 'completed'
                } else if (list.started == 1) {
                    list.status = 'progress'
                }

                // Loop for all sections
                Object.keys(list.sections).map(function(sec_id, o) {
                    var section = list.sections[sec_id]

                    section.completed = 0
                    section.total = 0
                    section.score = 0
                    section.total_score = 0

                    // Loop for all items
                    Object.keys(section.items).map(function(item_id, i) {
                        var item = section.items[item_id]
                        item.is_visible = true
                        item.alerts = false

                        // Subtasks
                        if (typeof item.conditions !== 'undefined' && item.conditions != null && item.conditions) {
                            var conditions = item.conditions
                            var current_show = null
                            var current_order = -1
                            var cond_operator = typeof conditions.operator !== 'undefined' ? conditions.operator : 'AND'
                            for (var key in conditions.values) {
                                var show = false
                                let condition = conditions.values[key]
                                // console.log( key,condition )
                                // console.log(section.items)
                                let value = section.items[key] ? section.items[key].value : false
                                item.is_visible = false

                                var operator = condition && condition.operator ? condition.operator : '='
                                var val = condition ? condition.value : false

                                if ((value !== null || [FORMAT.CHECK, FORMAT.DOCUMENT].includes(section.items[key].type)) && section.items[key] && section.items[key].is_visible) {
                                    if (operator == 'true' && val == 'true') {
                                        show = true
                                    } else {
                                        // Get task type from parent
                                        switch (section.items[key].type) {
                                            //   switch (item.type) {
                                            case FORMAT.EMAIL:
                                            case FORMAT.DOCUMENT:
                                            case FORMAT.CHECK:
                                            case FORMAT.YESNO:
                                                show = compare(parseInt(val) == 1, value == true || value == 'true', operator)
                                                break
                                            case FORMAT.YESNONC:
                                                show = compare(val || (val == '' && operator == '!empty'), value, operator)
                                                break
                                            case FORMAT.MULTIPLE:
                                                show = compare(val || (val == '' && operator == '!empty'), value, operator)
                                                break
                                            case FORMAT.TEXT:
                                            case FORMAT.TEXTAREA:
                                            case FORMAT.PHOTO:
                                            case FORMAT.DATE:
                                            case FORMAT.TIME:
                                            case FORMAT.DATETIME:
                                            case FORMAT.SIGNATURE:
                                                show = compare(val, value, operator)
                                                break
                                            case FORMAT.NUMBER:
                                                var aux = value.toString().replace(',', '.')
                                                show = compare(parseFloat(aux), val, operator) || (value != '-' && operator == '!empty')
                                                break
                                            case FORMAT.TEMPERATURE:
                                                var aux = value.toString().replace(',', '.')
                                                show = compare(parseFloat(aux), val, operator) || (value != '-' && operator == '!empty')
                                                break
                                            default:
                                                break
                                        }
                                    }
                                }

                                if (current_show == null) current_show = show
                                else {
                                    switch (cond_operator) {
                                        case 'AND':
                                            current_show = current_show && show
                                            break
                                        case 'OR':
                                            current_show = current_show || show
                                            break
                                    }
                                }
                                if (show) {
                                    current_order = section.items[key].order
                                }
                            }

                            item.is_visible = current_show
                            item.order = parseInt(current_order) + 0.5
                        }

                        // Alerts TODO
                        if (item.alerts_triggers) {
                            let alerts = item.alerts_triggers
                            let value = item.value

                            let oAlert = {}
                            let message = ''
                            let preview = ''
                            let issues = []
                            let classes = []

                            for (var i in alerts) {
                                let alert = alerts[i]
                                //   console.log('alert', alert, value)
                                let operator = alert.operator ? alert.operator : '='
                                let val = alert.value

                                let show = false

                                if ((value !== null || [FORMAT.CHECK, FORMAT.DOCUMENT].includes(item.type)) && item.is_visible) {
                                    if (operator == 'true' && val == 'true') {
                                        show = true
                                    } else {
                                        switch (item.type) {
                                            case FORMAT.EMAIL:
                                            case FORMAT.DOCUMENT:
                                            case FORMAT.CHECK:
                                            case FORMAT.YESNO:
                                                show = compare(parseInt(val) == 1 || (val == '' && operator == '!empty'), value == true || value == 'true', operator)
                                                break
                                            case FORMAT.YESNONC:
                                                show = compare(parseInt(val) || (val == '' && operator == '!empty'), value, operator)
                                                break
                                            case FORMAT.MULTIPLE:
                                                show = compare(val || (val == '' && operator == '!empty'), value, operator)
                                                break
                                            case FORMAT.TEXT:
                                            case FORMAT.TEXTAREA:
                                            case FORMAT.PHOTO:
                                            case FORMAT.DATE:
                                            case FORMAT.TIME:
                                            case FORMAT.DATETIME:
                                            case FORMAT.SIGNATURE:
                                                show = compare(val, value, operator)
                                                break
                                            case FORMAT.NUMBER:
                                                var aux = value.toString().replace(',', '.')
                                                show = compare(parseFloat(aux), val, operator) || (value != '-' && operator == '!empty')
                                                break
                                            case FORMAT.TEMPERATURE:
                                                var aux = value.toString().replace(',', '.')
                                                show = compare(parseFloat(aux), val, operator) || (value != '-' && operator == '!empty')
                                                break
                                            default:
                                                break
                                        }
                                    }
                                }

                                if (show && alert.msg) {
                                    if (message == '') message = alert.msg
                                    else message = message + '<br/>' + alert.msg

                                    if (preview == '') preview = alert.msg
                                    else preview = preview + ', ' + alert.msg
                                }

                                if (show && alert.tpl) {
                                    issues.push(alert.tpl)
                                }
                                if (show && alert.class) {
                                    if (alert.class == 'alert') {
                                        alert.class = 'warning'
                                    }
                                    classes.push(alert.class)
                                }
                            }

                            oAlert = {
                                preview: preview,
                                message: message,
                                issues: issues,
                                class: classes
                            }

                            if (oAlert.message.length > 0 || oAlert.issues.length > 0) {
                                item.alerts = oAlert
                                Vue.set(item, 'alerts', oAlert)
                            }
                        }

                        // CALC SCORE PROPIO DE AUDITS
                        if (((!item.parent_id && list.def.item.itemsExcluded.indexOf(item.type) == -1) || (item.parent_id && item.is_visible)) && !item.planned_to_date && item.apply) {
                            item.score = 0
                            let scoreTotal = item.param && item.param.total ? item.param.total : 0
                            let conditions = item.param && item.param.conditions ? item.param.conditions : []
                            let value = item.value
                            let result = 0
                            let show = false

                            if (!show) {
                                for (var i in conditions) {
                                    let param = conditions[i]
                                    let operator = param.operator ? param.operator : '='
                                    let val = param.value
                                    let score = param.p

                                    if ((value !== null || [FORMAT.CHECK, FORMAT.DOCUMENT].includes(item.type) || !item.apply) && item.is_visible) {
                                        switch (item.type) {
                                            case FORMAT.EMAIL:
                                            case FORMAT.DOCUMENT:
                                            case FORMAT.CHECK:
                                            case FORMAT.YESNO:
                                                show = compare(parseInt(val) == 1, value == true || value == 'true', operator)
                                                break
                                            case FORMAT.YESNONC:
                                                show = compare(val || (val == '' && operator == '!empty'), value, operator)
                                                break
                                            case FORMAT.MULTIPLE:
                                                show = compare(val || (val == '' && operator == '!empty'), value, operator)
                                                break
                                            case FORMAT.TEXT:
                                            case FORMAT.TEXTAREA:
                                            case FORMAT.PHOTO:
                                            case FORMAT.DATE:
                                            case FORMAT.TIME:
                                            case FORMAT.DATETIME:
                                            case FORMAT.SIGNATURE:
                                                show = compare(val, value, operator)
                                                break
                                            case FORMAT.NUMBER:
                                                var aux = value.toString().replace(',', '.')
                                                show = compare(parseFloat(aux), val, operator) || (value != '-' && operator == '!empty')
                                                break
                                            case FORMAT.TEMPERATURE:
                                                var aux = value.toString().replace(',', '.')
                                                show = compare(parseFloat(aux), val, operator) || (value != '-' && operator == '!empty')
                                                break
                                            default:
                                                break
                                        }
                                        if (show) {
                                            item.score = score
                                            section.completed = parseFloat(section.completed) + parseFloat(item.score)
                                            list.completed = parseFloat(list.completed) + parseFloat(item.score)
                                        }
                                    }
                                }
                            }
                            // Posible total score
                            list.total_score = parseFloat(list.total_score) + parseFloat(scoreTotal)
                            section.total_score = parseFloat(section.total_score) + parseFloat(scoreTotal)

                            // Total tal cual de items
                            if (![FORMAT.LINK, FORMAT.RESOURCE].includes(item.type)) {
                                list.total++
                                section.total++
                            }
                        }

                        section.items[item.item_id] = { ...item }
                        Vue.set(section.items, item.item_id, { ...item })
                    })

                    section.score = Math.round((parseFloat(section.completed) * 100) / parseFloat(section.total_score))

                    template.total_score = parseFloat(template.total_score) + parseFloat(list.total_score)
                    template.total = parseFloat(template.total) + parseFloat(list.total)
                    template.completed = parseFloat(template.completed) + parseFloat(list.completed)

                    list.sections[section.section_id] = { ...section }
                    Vue.set(list.sections, section.section_id, { ...section })
                })

                list.score = list.total_score == 0 ? 0 : Math.round((parseFloat(list.completed) * 100) / parseFloat(list.total_score))

                if (last_audits.includes(list.id)) {
                    template.last_score = parseFloat(template.last_score) + parseFloat(list.score)
                }

                aItems[list.id] = { ...list }
            }
        })

        // ORDER
        Object.keys(aItems).map(function(item_id, i) {
            let list = JSON.parse(JSON.stringify(aItems[item_id]))
            // console.log(list)
            Object.keys(list.sections).map(function(sec_id, o) {
                var section = list.sections[sec_id]
                var items = Object.keys(section.items)
                    .sort((a, b) => {
                        return parseFloat(list.sections[sec_id].items[a].order) - parseFloat(list.sections[sec_id].items[b].order)
                    })
                    .reduce((prev, curr, i) => {
                        prev[i] = list.sections[sec_id].items[curr]
                        return prev
                    }, {})

                let aux2 = {}
                for (var k in items) {
                    aux2[items[k].item_id] = items[k]
                }
                section.items = aux2
            })
            aItems[item_id] = list
        })

        Object.keys(aTemplates).map(function(tpl_id, o) {
            var template = aTemplates[tpl_id]

            template.total_score = parseFloat(template.total_score) == 0 ? 0 : Math.round((parseFloat(template.completed) * 100) / parseFloat(template.total_score))
        })

        commit('setTemplates', { data: aTemplates })
        commit('setScore', { items: aItems })
    },

    // Audits
    loadItems({ state, context, commit, dispatch, rootState }, params = {}) {
        return api.post('checklist/resume/' + params.template, { type: state.type }).then(function(response) {
            dispatch('format', { data: response.data.values })
            dispatch('calcScore')
            commit('setResume', { data: response.data.schema })
        })
    },
    changeSupervisor({ state, context, commit, dispatch, rootState }, params = {}) {
        commit('setSupervisor', { id: params.emp_id })
    },

    loadFromDate({ state, context, commit, dispatch, rootState }, params = {}) {
        params.date = params.date ? params.date : moment().format('YYYY-MM-DD')

        return api.get('checklist/' + state.type + '/' + params.date, {}).then(function(response) {
            return response
        })
    }
}

// mutations
const mutations = {
    // Commonisimos, está en todos los modules
    resetState(state) {
        Object.assign(state, getDefaultState())
    },

    // Commons
    setTemplates(state, payload) {
        var templates = {}

        if (payload.data != undefined) {
            Object.keys(payload.data).map(function(tpl_id, i) {
                var tpl = { ...payload.data[tpl_id] }

                tpl.last_update = tpl.last_update ? (moment.isMoment(tpl.last_update) ? tpl.last_update : moment(tpl.last_update * 1000)) : false

                tpl.last_score = tpl.last_score && !Number.isNaN(tpl.last_score) ? tpl.last_score : 0
                tpl.total_score = tpl.total_score && !Number.isNaN(tpl.total_score) ? tpl.total_score : 0
                tpl.total = tpl.total && !Number.isNaN(tpl.total) ? tpl.total : 0
                tpl.completed = tpl.completed && !Number.isNaN(tpl.completed) ? tpl.completed : 0

                templates[tpl.id] = tpl
            })
        }

        state.templates = templates
        Vue.set(state, 'templates', { ...templates })
    },

    setTemplate(state, template) {
        var templates = { ...state.templates }
        templates[template.id] = template

        state.templates = templates
        Vue.set(state, 'templates', { ...templates })
    },

    setItem(state, item) {
        var items = { ...state.items }
        items[item.id] = item

        state.items = items
        Vue.set(state, 'items', { ...items })
    },

    removeItem(state, id) {
        var items = { ...state.items }
        delete items[id]

        state.items = items
        Vue.set(state, 'items', { ...items })
    },

    resetStats(state, payload) {
        state.stats.alerts = {}
        state.stats.activity = {}
    },
    setStats(state, payload) {
        state.stats[payload.where] = {}
        state.stats[payload.where][payload.key_name] = payload.values
    },

    setFormat(state, payload) {
        state.items = payload.items
        Vue.set(state, 'items', { ...payload.items })
    },
    setScore(state, payload) {
        state.items = payload.items
        Vue.set(state, 'items', { ...payload.items })
    },

    // Common but may change in other tools
    setAnswerProp(state, payload) {
        var check = payload.check
        var answer = payload.answer
        var prop = payload.prop
        var value = payload.value
        var section = payload.getters['getSectionFromItem'](check, answer)

        state.items[check].sections[section].items[answer][prop] = value

        Vue.set(state, 'items', { ...state.items })
    },
    setComment(state, payload) {
        let check = payload.check
        let answer = payload.answer
        var section = payload.getters['getSectionFromItem'](check, answer)

        let aux = state.items[check].sections[section].items[answer]
        aux.message = payload.message
        aux.image = payload.image ? payload.image : false

        Vue.set(state.items[check].sections[section].items, answer, { ...aux })
        Vue.set(state, 'items', { ...state.items })
    },
    setAnswer(state, payload) {
        var check = payload.check
        var answer = payload.answer
        var emp = payload.emp
        var value = payload.value
        var date = payload.date
        var section = payload.getters['getSectionFromItem'](check, answer)

        state.items[check].sections[section].items[answer].value = value

        if (date) {
            var item = state.items[check].sections[section].items[answer]
            item.complete_date = !moment.isMoment(date) && date != false ? moment(date * 1000) : item.complete_date
        }
        if (emp) state.items[check].sections[section].items[answer].employee = emp

        Vue.set(state, 'items', { ...state.items })
    },
    setApply(state, payload) {
        const check = payload.check
        const answer = payload.answer
        const emp = payload.emp
        const apply = payload.apply
        const date = payload.date
        const section = payload.getters['getSectionFromItem'](check, answer)

        state.items[check].sections[section].items[answer].apply = apply
        state.items[check].sections[section].items[answer].value = null

        if (date) {
            state.items[check].sections[section].items[answer].complete_date = !moment.isMoment(date) && date != false ? moment(date * 1000) : item.complete_date
        } else {
            state.items[check].sections[section].items[answer].complete_date = false
        }

        if (emp) {
            state.items[check].sections[section].items[answer].employee = emp
        }

        Vue.set(state, 'items', { ...state.items })
    },
    setReset(state, payload) {
        if (payload.getters != undefined) {
            var check = payload.check
            var answer = payload.answer
            var section = payload.getters['getSectionFromItem'](check, answer)

            state.items[check].sections[section].items[answer].complete_date = false
            state.items[check].sections[section].items[answer].employee = false
            state.items[check].sections[section].items[answer].review = false
            state.items[check].sections[section].items[answer].value = null

            Vue.set(state, 'items', { ...state.items })
        }
    },
    setValidation(state, payload) {
        var check = payload.check
        var answer = payload.answer
        var emp = payload.emp
        var date = payload.date
        var section = payload.getters['getSectionFromItem'](check, answer)

        state.items[check].sections[section].items[answer].review = {}
        if (date) {
            var item = state.items[check].sections[section].items[answer].review
            item.complete_date = !moment.isMoment(date) && date != false ? moment(date * 1000) : item.complete_date
        }
        if (emp) {
            var employee = store.getters['employee/getEmployee'](emp)
            state.items[check].sections[section].items[answer].review.employee = employee
        }
        state.items[check].sections[section].items[answer].review.value = 1

        Vue.set(state, 'items', { ...state.items })
    },
    setUnvalidation(state, payload) {
        var check = payload.check
        var answer = payload.answer
        var section = payload.getters['getSectionFromItem'](check, answer)

        state.items[check].sections[section].items[answer].review = false

        Vue.set(state, 'items', { ...state.items })
    },

    // Audits
    setResume(state, payload) {
        var aItems = {}

        Object.keys(payload.data).map(function(id, i) {
            var item = payload.data[id]

            if (item.type == '8') {
                aItems[item.id] = item
            }
        })

        state.headers = aItems
        Vue.set(state, 'headers', aItems)
    },
    setSupervisor(state, payload) {
        state.supervisor = payload.id
        Vue.set(state, 'supervisor', payload.id)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
